import { useState } from "react";
import { ListPlus, Send } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { parseChat, uid } from "@/lib/chat";

export const PasteInput = ({ onParsed }) => {
  const [raw, setRaw] = useState("");
  return (
    <div className="space-y-3">
      <Textarea data-testid="paste-text-input" value={raw} onChange={(e) => setRaw(e.target.value)} rows={7} maxLength={20000}
        placeholder={"Paste the chat, one message per line. Prefix lines with a name to label speakers:\nRiya: hey, you up?\nMe: barely 😅\nRiya: same lol"}
        className="rounded-2xl text-sm" />
      <button data-testid="parse-text-button" disabled={!raw.trim()} onClick={() => onParsed(parseChat(raw))}
        className="w-full h-11 rounded-full brand-gradient text-white font-semibold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-40">
        <ListPlus className="h-4 w-4" /> Load into transcript
      </button>
      <p className="text-xs text-muted-foreground">Lines starting with “Me:” or “You:” are marked as yours; other names are marked as them. Unlabelled lines can be set below.</p>
    </div>
  );
};

export const QuickInput = ({ onParsed }) => {
  const [latest, setLatest] = useState("");
  const [earlier, setEarlier] = useState("");
  const submit = () => {
    const msgs = [...parseChat(earlier), { id: uid(), speaker: "them", text: latest.trim() }];
    onParsed(msgs, msgs[msgs.length - 1].id);
  };
  return (
    <div className="space-y-3">
      <label className="text-sm font-medium" htmlFor="quick-latest">Their latest message</label>
      <Input id="quick-latest" data-testid="quick-latest-input" value={latest} onChange={(e) => setLatest(e.target.value)} maxLength={1000}
        placeholder="e.g. You always have something funny to say 😂" className="h-12 rounded-xl" />
      <label className="text-sm font-medium block" htmlFor="quick-earlier">Earlier messages <span className="text-muted-foreground font-normal">(optional context)</span></label>
      <Textarea id="quick-earlier" data-testid="quick-earlier-input" value={earlier} onChange={(e) => setEarlier(e.target.value)} rows={3} maxLength={8000}
        placeholder={"Me: that meme was so accurate\nThem: lmao right"} className="rounded-xl text-sm" />
      <button data-testid="quick-submit-button" disabled={!latest.trim()} onClick={submit}
        className="w-full h-11 rounded-full brand-gradient text-white font-semibold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-40">
        <Send className="h-4 w-4" /> Use this message
      </button>
    </div>
  );
};
